module.exports = __webpack_public_path__ + "media/images/paypal-be5549fbab5d458c15f834602fca65ca.png";